import { BASE_SEO_SET_META, BASE_SEO_RESET_META } from 'rebook/apps/base/constants';


const defaultState = {
  title: 'Электронная библиотека MyBook — читайте книги в онлайн библиотеке. ' +
         'Новинки и бестселлеры литературы в библиотеке электронных книг.',
  description: `В электронной библиотеке MyBook можно прочитать ` +
               `более 166000 электронных книг. ` +
               `Для онлайн чтения доступны шедевры современной и классической литературы. ` +
               `Новинки и бестселлеры, отзывы, рекомендации, популярные авторы.`,
  // will be obsolete when desktop & mobile rebook are merged
  robots: null,
  canonicalUrl: null,
  pageNumber: null,
  // https://stackoverflow.com/questions/19274463/what-is-link-rel-image-src
  imageSrc: null,
  ogTags: null,
  ogBookTags: null,
  // by default expose the app card tags
  // https://developer.twitter.com/en/docs/tweets/optimize-with-cards/overview/app-card
  // https://developer.twitter.com/en/docs/tweets/optimize-with-cards/overview/summary
  ogTwitterTags: [
    { name: 'card', value: 'app' },
    { name: 'app:name:iphone', value: 'MyBook' },
    { name: 'app:name:ipad', value: 'MyBook' },
    { name: 'app:id:iphone', value: '556540446' },
    { name: 'app:id:ipad', value: '556540446' },
    { name: 'app:name:googleplay', value: 'MyBook' },
    { name: 'app:id:googleplay', value: 'ru.mybook' },
  ],
};

export default function seo(state = defaultState, action) {
  switch (action.type) {
    case BASE_SEO_SET_META:
      return {
        ...state,
        ...action.payload,
      };
    case BASE_SEO_RESET_META:
      return {
        ...defaultState,
      };
    default:
      return state;
  }
}
